import React from 'react';
import { Link } from 'react-router-dom';

const stripeCheckoutUrl = (process.env.REACT_APP_STRIPE_CHECKOUT_URL || '').trim();

type TrialCtaProps = {
  className?: string;
  children: React.ReactNode;
  /** Override default `/start-checkout` (e.g. Betfair promo). Ignored when REACT_APP_STRIPE_CHECKOUT_URL is set. */
  checkoutPath?: string;
};

/** Primary subscribe CTA — same behaviour on landing and marketing chrome (e.g. user guide). */
const TrialCta: React.FC<TrialCtaProps> = ({ className = '', children, checkoutPath = '/start-checkout/betfair' }) => {
  const classes = ['btn', 'btn-primary', className].filter(Boolean).join(' ');
  if (stripeCheckoutUrl) {
    return (
      <a href={stripeCheckoutUrl} className={classes} target="_blank" rel="noopener noreferrer">
        {children}
      </a>
    );
  }
  return (
    <Link to={checkoutPath} className={classes}>
      {children}
    </Link>
  );
};

export default TrialCta;
